import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  span {
    font-weight: 600;
  }

  mark,
  .marcacao {
    color: #f49d1a;
    background: ${(props) => props.theme.cores.neutro[0]};
  }
`;

export const Linha = styled.div`
  display: flex;
  column-gap: 20px;

  height: 30px;

  @media screen and (max-width: 367px) {
    display: flex;
    flex-direction: column;
    row-gap: 10px;

    height: 50px;
  }
`;

export const BaixarPagina = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  width: fit-content;

  svg {
    font-size: 1.25rem;

    fill: ${({ theme: { cores } }) => cores.primaria.padrao};
  }

  p {
    color: ${({ theme: { cores } }) => cores.primaria.padrao};

    font-weight: 500;
    font-size: 1rem;
    text-decoration: underline;
  }

  &:hover {
    cursor: pointer;

    p {
      color: ${({ theme: { cores } }) => cores.primaria.variantes[800]};

      font-weight: 600;
    }

    svg {
      fill: ${({ theme: { cores } }) => cores.primaria.variantes[800]};
    }
  }

  @media (max-width: 844px) {
    font-size: 0.875rem;
  }
`;
